'use client';

import { createContext } from 'react';

import type { TableRowContextInterface } from '../types/table-row.types';

export const TableRowContext = createContext<TableRowContextInterface>({});

TableRowContext.displayName = 'Table.Row.Context';
